
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rejestracja-pracodawca",
      function () {
        return require("private-next-pages/rejestracja-pracodawca.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rejestracja-pracodawca"])
      });
    }
  